function definePageModuleLoader(selector, importer) {
  return {
    selector,
    load: async () => {
      const module = await importer();

      return module.default ?? module;
    },
  };
}

const workshopConfigLoader = definePageModuleLoader('[data-workshop-config]', () => import('./unturned-workshop-download-config'));
const sourceViewerLoader = definePageModuleLoader('form[data-uscript-submit], [data-uscript-source-viewer]', () => import('./uscript-submit'));
const powerGridLoader = definePageModuleLoader('.power-grid-table, #power-grid-table-base, #pg-footer', () => import('../../vendor/power-components/livewire-powergrid/dist/powergrid'));
const communityRequestLoader = definePageModuleLoader('[data-community-request-form], [data-community-request-select]', () => import('./community-request-form'));
const communityRequestGalleryLoader = definePageModuleLoader('[data-community-request-gallery]', () => import('./community-request-gallery'));
const messagesInboxLoader = definePageModuleLoader('[data-conversation-thread]', () => import('./messages-inbox'));
const tomSelectLoader = definePageModuleLoader('[data-tom-select]', () => import('./tom-select'));

const sharedPageModuleLoaders = [
  workshopConfigLoader,
  sourceViewerLoader,
  powerGridLoader,
  communityRequestLoader,
  communityRequestGalleryLoader,
  messagesInboxLoader,
  tomSelectLoader,
];

export const sitePageModuleLoaders = [
  definePageModuleLoader('[data-color-catalog]', () => import('./color-catalog')),
  definePageModuleLoader('[data-difficulty-editor]', () => import('./difficulty-editor')),
  definePageModuleLoader('[data-random-keygen]', () => import('./random-keygen')),
  definePageModuleLoader('[data-server-settings]', () => import('./unturned-server-settings')),
  definePageModuleLoader('[data-unturned-commands]', () => import('./unturned-commands')),
  definePageModuleLoader('[data-permission-editor]', () => import('./rocketmod-permissions')),
  definePageModuleLoader('[data-plugin-catalog]', () => import('./plugin-catalog')),
  definePageModuleLoader('[data-library-catalog]', () => import('./library-catalog')),
  definePageModuleLoader('[data-uscript-docs]', () => import('./uscript-docs')),
  definePageModuleLoader('[data-profile-visibility-select]', () => import('./profile-visibility')),
  definePageModuleLoader('[data-contact-subject-select]', () => import('./contact')),
  ...sharedPageModuleLoaders,
];

export const adminPageModuleLoaders = [
  definePageModuleLoader('[data-admin-plugin-single-select]', () => import('./admin-plugin-manager')),
  definePageModuleLoader('[data-admin-library-dropzone]', () => import('./admin-library-manager')),
  ...sharedPageModuleLoaders,
];
